import { user } from '../../utils';
import { OfferResponseEvent } from '../../Shared/events';
import { OfferResponseBIModel } from '../models';
import { track } from '../../tracking/bi-track';

export const offerResponseBIEventListener = () => {
    document.addEventListener(OfferResponseEvent.eventType, (offerResponseEvent) => {
        const offerResponseBIModel = OfferResponseBIModel.createFromDomainEvent(user.id, offerResponseEvent);
        track(offerResponseBIModel);
    });
};